import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';
import { useEscaCopy } from '../../i18n/escaCopy';
const EASE = [0.23, 1, 0.32, 1] as const;
export function ShortlistSection() {
  const {
    lang
  } = useLanguage();
  const c = useEscaCopy(lang);
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const total = c.shortlist.stages.length;
  return <section className="bg-sand py-20 lg:py-28" ref={ref} data-id="element-504" data-mp="2egxlblpwdxwu">
      <div className="max-w-[88rem] mx-auto px-5 sm:px-8" data-id="element-505" data-mp="2efcqrw3l2eyz">
        <div className="grid lg:grid-cols-[minmax(0,34rem)_1fr] gap-12 lg:gap-20" data-id="element-506" data-mp="29h2rb9atss7k">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={inView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.55,
          ease: EASE
        }} data-id="element-507" data-mp="25giw4b9tbyo2">
            <h2 className="esca-h2 text-ink text-balance" data-id="element-508" data-mp="3ow9elwyepxe">
              {c.shortlist.title}
            </h2>
            <p className="esca-lead mt-6 text-muted max-w-[48ch]" data-id="element-509" data-mp="3aesmfw3djw3o">
              {c.shortlist.lead}
            </p>
          </motion.div>

          {/* Funnel */}
          <div className="relative" data-id="element-510" data-mp="3fbj06crpiflx">
            <div className="mb-4 flex items-center gap-2" data-id="element-511" data-mp="31eci6ket4kxr">
              <span className="w-1.5 h-1.5 bg-accent" aria-hidden="true" data-id="element-512" data-mp="31fxf2golgfys" />
              <span className="text-[0.6875rem] tracking-[0.12em] uppercase text-muted" data-id="element-513" data-mp="3t50ftmh9v86o">
                {c.shortlist.demoNote}
              </span>
            </div>

            <div className="flex flex-col gap-2" data-id="element-514" data-mp="1xxpex99d5xi">
              {c.shortlist.stages.map((s, i) => {
              const widthPct = 100 - i / total * 44;
              const isLast = i === total - 1;
              return <motion.div key={s.label} initial={{
                opacity: 0,
                x: -12
              }} animate={inView ? {
                opacity: 1,
                x: 0
              } : {}} transition={{
                duration: 0.5,
                delay: 0.15 + i * 0.09,
                ease: EASE
              }} style={{
                ['--bar-w' as string]: `${widthPct}%`
              }} className={`w-full lg:w-[var(--bar-w)] flex items-baseline gap-4 sm:gap-5 px-5 sm:px-6 py-4 sm:py-5 lg:py-6 ${isLast ? 'bg-accent text-white' : 'bg-white border border-line'}`} data-id="element-515" data-mp="fyi7fr7cmxpy" data-mpi={i}>
                    <span className={`font-display text-2xl lg:text-[2.25rem] font-bold tabular-nums tracking-[-0.035em] leading-none ${isLast ? 'text-white' : 'text-ink'}`} data-id="element-516" data-mp="6ujx3284kb75">
                      {s.value}
                    </span>
                    <span className={`text-[0.875rem] leading-snug ${isLast ? 'text-white/85' : 'text-muted'}`} data-id="element-517" data-mp="3p0g5tf1r6wlh">
                      {s.label}
                    </span>
                  </motion.div>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
}